import React, { Fragment, useState, useEffect } from 'react';
import { useGatewayList, useDeleteGateway, useStatusRfid } from 'hooks/configuration/rfid/rfid';
import { PAGES, ACTIONS, usePermissions } from 'hooks/permissions/permissions';
import StatusBadge from 'components/statusBadge';
import { QuestionCircleOutlined, SortDescendingOutlined, SortAscendingOutlined } from '@ant-design/icons';
import { Row, Col, Button, Input, Pagination, message, Popconfirm } from 'antd';
import { calculateEightHoursAgo, formatLastDetected, statusColor, PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE } from "helpers/commonFunctions";
import { Link } from 'react-router-dom';
import Image from 'helpers/Image';
import "../style.css";
import TableStateRow from "components/tableState";

const Rfid = () => {
    const { can } = usePermissions();
    const canAdd = can(PAGES.RFID_READER, ACTIONS.ADD);
    const canEdit = can(PAGES.RFID_READER, ACTIONS.EDIT);
    const canDelete = can(PAGES.RFID_READER, ACTIONS.DELETE);
    const showActions = canEdit || canDelete;
    const columnCount = showActions ? 9 : 8;
    const [page, setPage] = useState(DEFAULT_PAGE_SIZE);
    const [listData, setListData] = useState(null);
    const [pageNumber, setPagenumber] = useState(0);
    const [searchKey, setSearchKey] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortMethod, setSortMethod] = useState("desc");
    const [defaultCall, setDefaultCall] = useState(false);
    const [initValues, setInitValues] = useState({
        "searchKey": searchKey,
        "pageNumber": pageNumber,
        "pageSize": page,
        "sortField": sortField,
        "sortMethod": sortMethod
    })
    const [sorting, setSorting] = useState({
        "r.rfid_id": null,
        "r.reader_name": null,
        "r.antenna_number": null,
        "r.antenna_type": null,
        "s.site_name": null,
        "l.location_name": null,
        "r.active": null,
    });
    const { mutate: getGatewayList, data: gatewayListData, isLoading: Loading } = useGatewayList();
    const { mutate: deleteGateway, isLoading: deleteLoading } = useDeleteGateway();
    const { mutate: statusChange } = useStatusRfid();
    const onSortChange = async (column) => {
        initValues.pageNumber = 0;
        initValues.sortField = column;
        initValues.sortMethod = sorting[column] === 'asc' ? 'desc' : 'asc';
        setPagenumber(0);
        const newSorting = {
            ...sorting,
            [column]: sorting[column] === 'asc' ? 'desc' : 'asc',
        };
        setSorting(newSorting);
        setInitValues(initValues);
        setSortField(column);
        setSortMethod(newSorting[column]);
        setListData([]);
    };
    const deleteId = (id) => {
        deleteGateway(id, {
            onSuccess: (item) => {
                if (item.statusCode === 200) {
                    message.success(item.message);
                    onFetchGatewayList(initValues);
                }
                else {
                    message.error(item?.message);
                }
            },
        });
    }
    const handleConfirmActive = (id) => {
        statusChange(id, {
            onSuccess: (item) => {
                if (item.statusCode === 200) {
                    message.success(item.message);
                    onFetchGatewayList(initValues);
                }
                else {
                    message.error(item?.message);
                }
            },
        });
    }
    const onFetchGatewayList = (values) => {
        getGatewayList(values, {
            onSuccess: (item) => {
                setListData(item?.data?.content);
            }
        })
    }

    const change = (page) => {
        initValues.pageNumber = page - 1;
        setInitValues(initValues);
        setPagenumber(page - 1);
    }

    const onShowSizeChange = (current, pageSize) => {
        setPage(initValues.pageSize = pageSize)
    }

    const onSearchHandler = (e) => {
        initValues.searchKey = e.target.value;
        let data = { ...initValues };
        data.searchKey = e.target.value;
        data.pageNumber = e.target.value !== "" ? 0 : initValues.pageNumber;
        e.target.value !== "" ? data.pageNumber = 0 : data.pageNumber = pageNumber;
        setInitValues(data);
        setPagenumber(data.pageNumber);
        setSearchKey(e.target.value);
    }
 useEffect(() => {
        setDefaultCall(true);
      }, [])
    useEffect(() => {
        if (defaultCall) {
        onFetchGatewayList(initValues);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultCall,pageNumber, searchKey, page, sortField, sortMethod,]);


    return (
        <Fragment>
            <div className="common-head">
                <div className="title">
                    <h1>RFID Readers</h1>
                    <p>Manage the RFID readers installed at each gate</p>
                </div>
                <div className="txt-right single-line">
                    <Input placeholder='Search' onChange={onSearchHandler} prefix={<Image className="search-img" name={"search.svg"} />} allowClear />
                    {!canAdd ? null : <Link to="/configuration/rfid/create">
                        <Button><Image name="plus.png" /> New RFID</Button>
                    </Link>}
                </div>
            </div>
            <div className="common-table">
                <table>
                    <thead>
                        <tr>
                            <th>Reader Name {sorting["r.reader_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("r.reader_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("r.reader_name")} />}</th>
                            <th>RFID ID {sorting["r.rfid_id"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("r.rfid_id")} /> : <SortDescendingOutlined onClick={() => onSortChange("r.rfid_id")} />}</th>
                            <th>Antenna Number {sorting["r.antenna_number"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("r.antenna_number")} /> : <SortDescendingOutlined onClick={() => onSortChange("r.antenna_number")} />}</th>
                            <th>Antenna Type {sorting["r.antenna_type"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("r.antenna_type")} /> : <SortDescendingOutlined onClick={() => onSortChange("r.antenna_type")} />}</th>
                            <th>Site {sorting["s.site_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("s.site_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("s.site_name")} />}</th>
                            {/* <th>Floor</th> */}
                            <th>Location {sorting["l.location_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("l.location_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("l.location_name")} />}</th>
                            <th>Last Detected</th>
                            <th>Status {sorting["r.active"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("r.active")} /> : <SortDescendingOutlined onClick={() => onSortChange("r.active")} />}</th>
                            {showActions ? <th>Action</th> : null}
                        </tr>
                    </thead>
                    <tbody>
                        {Loading ? (
                            <TableStateRow colSpan={columnCount} loading />
                        ) : listData == null || listData === undefined || listData?.length === 0 ? (
                            <TableStateRow colSpan={columnCount}>No RFID readers found</TableStateRow>
                        ) : listData.map((item, a) => (
                                <tr key={a}>
                                    <td>{item?.readerName}</td>
                                    <td>{item?.rfidId}</td>
                                    <td>{item?.antennaNumber}</td>
                                    <td>{item?.antennaType}</td>
                                    <td>{item?.siteName}</td>
                                    {/* <td>{item?.floorName}</td> */}
                                    <td>{item?.location}</td>
                                    {item?.lastDetectedAt
                                        ? <td className={calculateEightHoursAgo(item?.lastDetectedAt) ? null : 'red'}>{formatLastDetected(item?.lastDetectedAt)}</td>
                                        : <td className='red'>Not Connected</td>}

                                    {/* <td><button className={statusColor(item.active)}>{item?.active ? "Active" : "InActive"}</button></td> */}
                                    <td>
                                        {canEdit ? <Popconfirm title={`Are you sure you want to ${item?.active === true ? "inactivate" : "activate"} this ${item?.readerName}?`}
                                            onConfirm={() => handleConfirmActive(item.rfidId)}
                                            icon={
                                                <QuestionCircleOutlined />
                                            }
                                            okText="Yes"
                                            cancelText="No">
                                            <button className={statusColor(item.active)}>
                                                {item?.active ? "Active" : "InActive"}
                                            </button>
                                        </Popconfirm> : <StatusBadge active={item?.active} />}
                                    </td>

                                    {showActions ? <td>{!canEdit ? null : <Link to={`/configuration/rfid/${item.rfidId}`} state={item}>
                                        <Image name="edit.png" />
                                    </Link>}
                                        {!canDelete ? null : <Popconfirm
                                            Loading={deleteLoading}
                                            title={`Are you sure to delete ${item?.readerName}?`}
                                            onConfirm={() => deleteId(item?.rfidId)}
                                            icon={
                                                <QuestionCircleOutlined />
                                            }
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Image name="delete.png" />
                                        </Popconfirm>}</td> : null}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            <Row className="table-pagination">
                <Col md={12}>
                    <h5>Showing {pageNumber === 0 ? 1 : (gatewayListData?.data?.pageable?.offset + 1 || 0)} to {page === 0 ? (gatewayListData?.data?.pageable?.offset + listData?.length || 0) : (gatewayListData?.data?.pageable?.offset + gatewayListData?.data?.numberOfElements || 0)} of {gatewayListData?.data?.totalElements} entries</h5>
                </Col>
                <Col md={12} className="txt-right">
                    {gatewayListData?.data?.content?.length === 0 ? null : <Pagination pageSize={page} showSizeChanger pageSizeOptions={PAGE_SIZE_OPTIONS} onChange={change} current={pageNumber + 1} onShowSizeChange={onShowSizeChange} total={gatewayListData?.data?.totalElements} />}
                </Col>
            </Row>
        </Fragment >
    )
}

export default Rfid;
